export const tr = {
    'categories-cannot-be-empty': 'Filtre en az bir kategori içermelidir',
    'condition-control-cannot-be-empty': 'Değer boş bırakılamaz',
    'condition-control-greater-or-equal-min': 'Değer, {min} değerine eşit veya üstünde olmalıdır',
    'condition-control-interval-size': 'Öğe sayısı, {min} ile {max} arasında olmalıdır',
    'condition-control-invalid-value': 'Hatalı değer',
    'condition-control-less-or-equal-max': 'Değer, {max} değerine eşit veya altında olmalıdır',
    'condition-invalid-format': 'Hatalı format',
    'condition-prohibited-symbols': 'Alan geçersiz karakterler içeriyor',
    'conditions-cannot-be-empty': 'Filtre en az bir koşul içermelidir',
    'conditions-must-be-unique': 'Filtre tekrarlanan koşullar içermemelidir',
    'default-error': 'Bilinmeyen hata: {errorCode}',
    'filters-must-be-unique': 'Bu kriterlere ve hedef kitleye sahip bir filtre zaten var',
    'name-cannot-be-empty': 'İsim boş bırakılamaz',
    'name-greater-than-max': 'İsmin uzunluğu {max} değerinin altında olmalıdır',
    'name-less-than-min': 'İsmin uzunluğu {min} değerinin üstünde olmalıdır',
    'name-prohibited-symbols': 'Filtre adı geçersiz karakterler içeriyor',
    'price-less-than-min': 'Teklif {min} {currency} altında olmamalıdır',
    'price-more-than-max': 'Teklif {max} {currency} üstünde olmamalıdır\r'
};
